import { isEmpty, isUndefined } from 'lodash';

import { Application, Environment } from '../../../../types';
import { Merge, WithRequired } from '../../../../utill-types';

export const hasAlternativeEnvironments = (
  application: Application
): application is WithRequired<Application, 'alternativeEnvironments'> =>
  !isUndefined(application.alternativeEnvironments) &&
  !isEmpty(application.alternativeEnvironments);

export const hasDevelopmentEnvironments = (
  application: Application
): application is Merge<
  Omit<Application, 'alternativeEnvironments'> & {
    alternativeEnvironments: { development: Environment };
  }
> =>
  hasAlternativeEnvironments(application) &&
  !isEmpty(application.alternativeEnvironments.development);

export const hasTestingEnvironments = (
  application: Application
): application is Merge<
  Omit<Application, 'alternativeEnvironments'> & {
    alternativeEnvironments: { testing: Environment };
  }
> =>
  hasAlternativeEnvironments(application) &&
  !isEmpty(application.alternativeEnvironments.testing);

export const hasAcceptanceEnvironments = (
  application: Application
): application is Merge<
  Omit<Application, 'alternativeEnvironments'> & {
    alternativeEnvironments: { acceptance: Environment };
  }
> =>
  hasAlternativeEnvironments(application) &&
  !isEmpty(application.alternativeEnvironments.acceptance);

export const hasProductionEnvironments = (
  application: Application
): application is Merge<
  Omit<Application, 'alternativeEnvironments'> & {
    alternativeEnvironments: { production: Environment };
  }
> =>
  hasAlternativeEnvironments(application) &&
  !isEmpty(application.alternativeEnvironments.production);
